import { render, staticRenderFns } from "./AdministratorEdit.vue?vue&type=template&id=2ac9f45c&scoped=true&"
import script from "./AdministratorEdit.vue?vue&type=script&lang=js&"
export * from "./AdministratorEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac9f45c",
  null
  
)

export default component.exports